import  React, {use, useEffect, useState} from 'react';
import errorImg from './../assets/img/ErrorImg.png';
import './styles/MensajeError.css';
import { hover } from '@testing-library/user-event/dist/hover';


//RePPrA
const MensajeError = ({ mensaje, show, onClose }) => {


    const handleCerrarMsgError = () => {
        if (onClose) { 
            onClose(); 
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className='mEMain'>
            <img src={errorImg} alt="Error" /> 
            <p>{mensaje}</p>
            <button className='buttonStandart' onClick={handleCerrarMsgError}>Aceptar</button>
        </div>
    );
};


export default MensajeError;